<template>
  <v-row>
    <v-col>
      <v-autocomplete
        :items="caseTypes"
        item-value="guid"
        item-text="name"
        outlined
        label="Ärendetyper"
        v-model="model"
        multiple
        :rules="[required]"
        hint="Obligatorisk"
        persistent-hint
        :loading="!caseTypes.length"
        :disabled="readonly"
      >
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { sync } from 'vuex-pathify'

export default {
  name: 'OdocLocationsInput',

  props: {
    caseTypes: Array,
    readonly: Boolean
  },

  data() {
    return { required }
  },

  computed: {
    model: sync('odoc/model@case_categories')
  }
}
</script>
